import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
    index: 0,
    selectedQuickLink: [
        {
            displayText: "myidM",
            id: 0,
        },
    ]
}

export const homeReducer = (state=initialState, action) => {
    switch(action.type){
        case ActionTypes.QUICK_LINK_SELECTED_INDEX: 
            return{
                ...state, 
                index: action.payload?.index
            }
        case ActionTypes.SELCTED_QUICK_LINK: 
            return{
                ...state, 
                selectedQuickLink: action.payload?.selectedQuickLink
            }
        default: 
            return state
    }
}